export default "__VITE_ASSET__W4GQY62w__"